import React from 'react';
import { Button, Grid, TextField } from '@mui/material';

const OpcoesResposta = ({ opcoesResposta, handleAddOpcao, handleOpcaoChange }) => {
  return (
    <Grid container direction="column" alignItems="flex-start" style={{ marginBottom: '20px' }}>
      <Button variant="outlined" color="primary" onClick={handleAddOpcao} style={{ marginBottom: '10px' }}>
        Adicionar Opção
      </Button>
      {opcoesResposta.map((opcao, index) => (
        <Grid container key={index} alignItems="center" style={{ marginBottom: '10px' }}>
          <TextField
            label="Digite uma opção"
            value={opcao}
            onChange={e => handleOpcaoChange(index, e.target.value)}
            variant="outlined"
            fullWidth
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default OpcoesResposta;
